"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const VoxeetRTCBase_1 = __importDefault(require("./VoxeetRTCBase"));
const debug_1 = __importDefault(require("debug"));
const VoxeetRTCShim_1 = require("./VoxeetRTCShim");
const Exceptions_1 = require("../Exceptions");
const AudioTagHelper_1 = __importDefault(require("../AudioTagHelper"));
const WebRtcUtils_1 = require("../WebRtcUtils");
const Utils_1 = require("../Utils");
const AudioProcess_1 = __importDefault(require("../AudioProcess"));
const config_1 = __importStar(require("../../config/config"));
const bowser_1 = __importDefault(require("bowser"));
const logging_1 = __importDefault(require("../../lib/logging"));
const MediaStream_1 = require("../../models/MediaStream");
const Helpers_1 = require("../../models/Helpers");
const events_1 = __importStar(require("../../events"));
/**
 * @ignore
 */
const debug = debug_1.default('vxt:rtc');
/**
 * @ignore
 */
const browser = bowser_1.default.getParser(window.navigator.userAgent);
const getPeerTracks = (stream, remoteScreenStream) => {
    const tracks = [...stream.getAudioTracks(), ...stream.getVideoTracks()];
    if (remoteScreenStream)
        tracks.push(...remoteScreenStream.getVideoTracks());
    return tracks;
};
const getTrackStats = (stats, track) => {
    let trackStats = null;
    if (stats.some((stat) => stat.type === 'track')) {
        // Chrome and Safari have track stats
        trackStats = stats.find((stat) => stat.type === 'track' && stat.trackIdentifier === track.id);
        trackStats.kind = track.kind; // Safari track stats do not have kind property
    }
    else {
        // Firefox does not have track stats
        trackStats = { type: 'track', id: track.id, kind: track.kind, trackIdentifier: track.id };
    }
    return trackStats;
};
const getInboundRtpStats = (stats, trackIdToSsrc, trackStats) => {
    const inboundRtpStats = stats.find((stat) => stat.type === 'inbound-rtp' && trackIdToSsrc.get(trackStats.trackIdentifier).includes(stat.ssrc));
    inboundRtpStats.trackId = trackStats.id; // Firefox inbound-rtp stats do not have trackId property
    return inboundRtpStats;
};
const getStreamStats = (stats, stream, trackStats, remoteScreenTrackIds, remoteScreenStreamMsid) => {
    if (stats.some((stat) => stat.type === 'stream')) {
        // Chrome has stream stats
        return stats.find((s) => s.type === 'stream' && s.trackIds.includes(trackStats.id));
    }
    else {
        //Firefox and Safari do not have stream stats
        if (remoteScreenTrackIds && remoteScreenTrackIds.includes(trackStats.trackIdentifier))
            return { type: 'stream', id: remoteScreenStreamMsid, streamIdentifier: remoteScreenStreamMsid, trackIds: [trackStats.id] };
        else
            return { type: 'stream', id: stream.id, streamIdentifier: stream.id, trackIds: [trackStats.id] };
    }
};
const areInboundRtpStatsAvailableForTrack = (stats, trackIdToSsrc, trackId) => {
    return stats.find((stat) => stat.type === 'inbound-rtp' && trackIdToSsrc.get(trackId).includes(stat.ssrc));
};
//CCS-1909
const shouldReportDisabledEchoCancellation = (audioTrack) => {
    const audioTrackSettings = audioTrack.getSettings();
    if (!audioTrackSettings || !('echoCancellation' in audioTrackSettings))
        return false;
    const audioTrackConstraints = audioTrack.getConstraints();
    if (!audioTrackConstraints)
        return false;
    return Utils_1.isBooleanConstraintEnabled(audioTrack.getConstraints(), 'echoCancellation', true) && !audioTrack.getSettings().echoCancellation;
};
class VoxeetRTCNative extends VoxeetRTCBase_1.default {
    static enumerateVideoDevices() {
        if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
            return navigator.mediaDevices.enumerateDevices().then((sources) => {
                let result = [];
                sources.forEach((source) => {
                    if (source.kind === 'videoinput') {
                        result.push(source);
                    }
                });
                return result;
            });
        }
        return Promise.reject(new Exceptions_1.BrowserNotSupportedError());
    }
    static enumerateAudioDevices(type = 'input') {
        if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
            return navigator.mediaDevices.enumerateDevices().then((sources) => {
                let result = [];
                sources.forEach((source) => {
                    if (source.kind === `audio${type}`) {
                        result.push(source);
                    }
                });
                return result;
            });
        }
        return Promise.reject(new Exceptions_1.BrowserNotSupportedError());
    }
    constructor(options = {}) {
        super(options);
        this.conferenceId = null;
        this.connection = null; // Unique peer connection impl
        this.peers = [];
        this.localMediaStream = null;
        this.sharingStream = null;
        this.sharingPeerConnection = null;
        this.audioTrack = null;
        this.speechThreshold = 0.2;
        this.constraints = null;
        this.processCb = null;
        this.lastStats = [];
        this.recentlySeenRTT = 0;
        this.audioTags = new AudioTagHelper_1.default(this, this.audio3D);
        this.blockedPeers = [];
        this.currentConstraints = null;
        this.bandwidth = null;
        this.audioTransceiver = null; // Master audio transceiver
        this.videoTransceiver = null; // Master video transceiver
        this.screenTransceiver = null; // Master screen transceiver
        this.remoteScreenStream = null;
    }
    autoplayBlockedEvent() {
        debug('autoplayBlockedEvent');
        this.emit('autoplayBlocked');
    }
    playBlockedAudio() {
        this.blockedPeers.forEach((peerId) => {
            this.peers
                .filter((p) => p.peerId === peerId && !p.isMaster)
                .map(() => {
                if (this.audioTags) {
                    this.audioTags.playAudioTag(peerId);
                }
            });
        });
        this.blockedPeers = [];
    }
    addStreamEvent(peerId, stream) {
        debug('addStreamEvent', peerId, stream);
        this.peers
            .filter((p) => p.peerId === peerId && !p.isMaster)
            .map(() => {
            this.audioTags.createAudioTag(peerId, stream).catch((error) => {
                if (this.blockedPeers.length === 0) {
                    this.autoplayBlockedEvent();
                }
                this.blockedPeers.push(peerId);
            });
        });
        if (this.localMediaStream && this.localMediaStream.id === stream.id)
            stream.type = MediaStream_1.MediaStreamType.Camera;
        this.emit('addStream', peerId, stream);
    }
    updateStreamEvent(peerId, stream) {
        debug('updateStreamEvent', peerId, stream);
        let peer = this.peers.find((p) => p.peerId === peerId);
        this.peers
            .filter((p) => p.peerId === peerId && !p.isMaster)
            .map(() => {
            this.audioTags.updateAudioTag(peerId, stream).catch((error) => {
                this.autoplayBlockedEvent(peerId);
            });
        });
        if (peer && !peer.closed) {
            if (this.localMediaStream && this.localMediaStream.id === stream.id)
                stream.type = MediaStream_1.MediaStreamType.Camera;
            // Fix for leaving the conference in unique peer
            this.emit('updateStream', peerId, stream);
        }
    }
    removeStreamEvent(peerId, stream) {
        debug('removeStreamEvent', peerId);
        let peer = this.peers.find((p) => p.peerId === peerId);
        if (peer && !peer.isMaster) {
            this.audioTags.removeAudioTag(peerId);
        }
        /*this.peers
          .filter((p) => p.peerId === peerId && !p.isMaster)
          .map(() => {
            this.audioTags.removeAudioTag(peerId);
          });*/
        if (peer && !peer.closed) {
            if (this.localMediaStream && this.localMediaStream.id === stream.id)
                stream.type = MediaStream_1.MediaStreamType.Camera;
            peer.stream = null;
            this.emit('removeStream', peerId, stream);
        }
    }
    getUserMediaWithChecks(constraints) {
        return __awaiter(this, void 0, void 0, function* () {
            const stream = yield navigator.mediaDevices.getUserMedia(constraints);
            const audioTracks = stream.getAudioTracks();
            if (audioTracks[0]) {
                if (shouldReportDisabledEchoCancellation(audioTracks[0]))
                    this.emit('error', Exceptions_1.EchoCancellationError());
            }
            return stream;
        });
    }
    init({ constraints, processCb, listenOnly, ownerId, options }) {
        return __awaiter(this, void 0, void 0, function* () {
            this.constraints = constraints;
            this.processCb = processCb;
            this.options = options;
            if (!browser.isBrowser('ie', true)) {
                this.audioContext = new VoxeetRTCShim_1.AudioContext();
            }
            if (!listenOnly && (constraints.audio || constraints.video)) {
                try {
                    this.localMediaStream = yield this.getUserMediaWithChecks(constraints);
                    this.audioTrack = this.localMediaStream.getAudioTracks()[0];
                }
                catch (err) {
                    throw new Exceptions_1.MediaStreamError(err);
                }
            }
        });
    }
    release() {
        return __awaiter(this, void 0, void 0, function* () {
            this.peers.map((p) => {
                this.closePeerConnection(p.peerId);
            });
            this.peers = [];
            if (this.audioTrack) {
                this.audioTrack.stop();
            }
            if (this.localMediaStream && this.localMediaStream.getVideoTracks()[0]) {
                // Stopping video
                this.localMediaStream.getVideoTracks()[0].stop();
            }
            if (this.sharingStream) {
                this.stopScreenShare();
            }
            if (this.audioContext) {
                this.audioContext.close();
            }
        });
    }
    isPeerConnectionStable() {
        const peer = this.peers.filter((p) => p.connection);
        if (peer.length > 0) {
            const connection = peer[0].connection;
            return connection.signalingState === 'stable';
        }
        return false;
    }
    createPeerConnection(peerId, state, isMaster) {
        return __awaiter(this, void 0, void 0, function* () {
            // In case of renegotiation, closes peer connection and saves the user's
            // position to update the new peer connection
            let isNew = false;
            let peer = this.peers.find((peer) => peer.peerId === peerId);
            let { connection } = peer ? peer : {};
            if (connection && state === 'close') {
                connection.close();
                connection = null;
            }
            if (!connection) {
                isNew = true;
                config_1.default.peerConnection.config.sdpSemantics = 'unified-plan'; // TODO: remove this recurrence VoxeetRTC.sdpSemantics();
                connection = new VoxeetRTCShim_1.RTCPeerConnection(config_1.default.peerConnection.config, config_1.default.peerConnection.constraints);
                connection.candidates = [];
                if (peer) {
                    peer.connection = connection;
                }
                else {
                    peer = {
                        peerId,
                        connection,
                        stream: null,
                        process: null,
                        isMaster,
                        closed: false,
                    };
                    this.peers.push(peer);
                }
                yield this.addConnectionListeners(peer);
                yield this.addTrackListeners(peerId, peer, { x: 0, y: 0.2 }, connection);
                connection.onicecandidate = (evt) => {
                    if (!evt.candidate) {
                        //Ice Gathering complete
                        this.iceCandidatesGatheringCompleteEvent(peerId, connection.candidates);
                    }
                    else {
                        //TODO: check if sdp non empty
                        connection.candidates.push({
                            sdpMid: evt.candidate.sdpMid,
                            sdpMLineIndex: evt.candidate.sdpMLineIndex,
                            sdp: evt.candidate.candidate,
                        });
                    }
                };
            }
            debug('createPeerConnection', this.peers);
            return { peer, isNew };
        });
    }
    addMasterStream(peer) {
        return __awaiter(this, void 0, void 0, function* () {
            debug('addMasterStream', peer);
            if (this.localMediaStream) {
                const isNew = !peer.stream;
                yield this.addStream(this.localMediaStream, peer.connection);
                peer.stream = this.localMediaStream;
                if (this.audioContext && this.localMediaStream.getAudioTracks().length > 0) {
                    peer.process = new AudioProcess_1.default(this.audioContext, this.localMediaStream, true, this.audio3D, this.processCb);
                    peer.process.connect();
                }
                if (isNew) {
                    this.addStreamEvent(peer.peerId, this.localMediaStream);
                }
                else {
                    this.updateStreamEvent(peer.peerId, this.localMediaStream);
                }
            }
        });
    }
    addConnectionListeners({ peerId, connection }) {
        return __awaiter(this, void 0, void 0, function* () {
            connection.oniceconnectionstatechange = (event) => {
                this.connectionStatusEvent({
                    peerId: peerId,
                    connectionStatus: event.target.iceConnectionState,
                    signalingState: event.target.signalingState,
                });
            };
            connection.onsignalingstatechange = (event) => {
                this.connectionStatusEvent({
                    peerId: peerId,
                    connectionStatus: event.target.iceConnectionState,
                    signalingState: event.target.signalingState,
                });
            };
        });
    }
    updateMasterStream(peerId, type, isMaster) {
        if (isMaster) {
            if (type === 'active' && this.constraints.audio) {
                return this.startAudioForPeer(peerId);
            }
            else if (type === 'inactive') {
                return this.stopAudioForPeer(peerId);
            }
        }
        return Promise.resolve();
    }
    closePeerConnection(peerId) {
        debug('closePeerConnection', peerId);
        const peer = this.peers.find((c) => c.peerId === peerId);
        if (peer) {
            this._closePeerConnectionForPeer(peer);
        }
        return Promise.resolve();
    }
    removePeerConnection(peerId) {
        var index = -1;
        var oldPeers = [];
        this.peers
            .filter((c) => c.peerId === peerId)
            .map((p) => {
            index = this.peers.indexOf(p);
        });
        if (index !== -1) {
            oldPeers = this.peers.splice(index, 1);
        }
        return oldPeers;
    }
    hasScreenShare() {
        return this.sharingStream !== null;
    }
    createAnswer(peerId, state = 'default', oid) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            debug('createAnswer', peerId, oid);
            const peer = this.peers.find((c) => c.peerId === peerId);
            if (!peer) {
                throw Exceptions_1.PeerNotFoundError(peerId);
            }
            let ssMsid = this.sharingStream ? this.sharingStream.id : 'none';
            try {
                const answer = yield peer.connection.createAnswer();
                if (!((_a = this.options) === null || _a === void 0 ? void 0 : _a.preferSendMono) || !((_b = this.options) === null || _b === void 0 ? void 0 : _b.preferRecvMono)) {
                    // Activating Stereo
                    answer.sdp = WebRtcUtils_1.activateStereoInSdp(answer.sdp, !((_c = this.options) === null || _c === void 0 ? void 0 : _c.preferSendMono), !((_d = this.options) === null || _d === void 0 ? void 0 : _d.preferRecvMono));
                }
                debug('Answer', answer.sdp);
                yield peer.connection.setLocalDescription(answer);
                this.sessionCreatedEvent(peerId, peer.connection.localDescription, null, ssMsid, state, oid);
            }
            catch (err) {
                logging_1.default.error('webrtc', 'VoxeetRTCNative.createAnswer', err);
                throw Exceptions_1.CreateAnswerError(err, peer.peerId);
            }
        });
    }
    createOffer(peerId) {
        logging_1.default.trace('createOffer, peerId');
        var peer = this.peers.find((c) => c.peerId === peerId);
        if (!peer) {
            return Promise.reject(new Exceptions_1.PeerNotFoundError(peerId));
        }
        return peer.connection
            .createOffer()
            .then((offer) => peer.connection.setLocalDescription(offer))
            .then(() => {
            debug('Offer', peer.connection.localDescription);
        })
            .catch((error) => {
            throw error;
        });
    }
    applyBandwidthConstraints(track) {
        return __awaiter(this, void 0, void 0, function* () {
            if (track) {
                //check track kind
                if (track.kind !== 'video')
                    return;
                if (!this.bandwidth)
                    return;
                if (this.constraints.video.height && this.constraints.video.width)
                    return;
                const videoSettingsConfig = Helpers_1.isMobile() ? config_1.videoSettings.mobile : config_1.videoSettings.desktop;
                const settings = videoSettingsConfig.find((setting) => this.bandwidth > setting.range.min && this.bandwidth <= setting.range.max);
                if (!settings)
                    return;
                if (this.currentConstraints !== null &&
                    this.currentConstraints.width === settings.dimensions.width &&
                    this.currentConstraints.height === settings.dimensions.height &&
                    this.currentConstraints.frameRate === settings.fps)
                    return;
                try {
                    yield track
                        .applyConstraints({
                        width: {
                            max: settings.dimensions.width,
                            ideal: settings.dimensions.width,
                        },
                        height: {
                            max: settings.dimensions.height,
                            ideal: settings.dimensions.height,
                        },
                        frameRate: { max: settings.fps, ideal: settings.fps },
                    })
                        .then((_) => {
                        this.currentConstraints = {
                            width: settings.dimensions.width,
                            height: settings.dimensions.height,
                            frameRate: settings.fps,
                        };
                        console.log('successfully applied');
                    }, (error) => logging_1.default.error(`failed to apply constraints: ${error}`));
                }
                catch (error) {
                    events_1.default.send(events_1.Events.ConferenceGlobalError.fromData(error));
                }
            }
        });
    }
    setRemoteDescription(peerId, ssrc, type, sdp, cb) {
        return __awaiter(this, void 0, void 0, function* () {
            debug('setRemoteDescription');
            debug('Offer', sdp);
            const getBandwidthRestriction = (sdp) => {
                // retrieve current browser
                const browser = bowser_1.default.getParser(window.navigator.userAgent);
                const modifier = browser.is('firefox') ? 'TIAS' : 'AS';
                // parse sdp
                const lines = sdp.split('\n').map((l) => l.trim()); // split and remove trailing CR
                const found = lines.find((line) => line.indexOf(`b=${modifier}:`) === 0);
                if (!found)
                    return undefined;
                const regex = new RegExp(':(.*)');
                return browser.is('firefox') ? parseInt(found.match(regex)[1]) / 1000 : parseInt(found.match(regex)[1]);
            };
            this.bandwidth = getBandwidthRestriction(sdp);
            const track = this.localMediaStream && this.localMediaStream.getVideoTracks()[0];
            yield this.applyBandwidthConstraints(track);
            yield Promise.all(this.peers
                .filter((c) => c.peerId === peerId)
                .map((c) => __awaiter(this, void 0, void 0, function* () {
                try {
                    yield c.connection.setRemoteDescription(new VoxeetRTCShim_1.RTCSessionDescription({ type: type, sdp: sdp }));
                }
                catch (err) {
                    logging_1.default.error('webrtc', 'VoxeetRTC.setRemoteDescription error: ', peerId, err);
                    throw Exceptions_1.RemoteDescriptionError(err, c.peerId);
                }
            })));
            // Safari not fireing onremovetrack for screenshare workaround
            if (browser.isBrowser('safari', true)) {
                yield Promise.all(this.peers
                    .filter((c) => c.peerId === peerId)
                    .map((p) => __awaiter(this, void 0, void 0, function* () {
                    if (this.remoteScreenStream) {
                        let lines = sdp.split('\n').map((l) => l.trim());
                        let current_mid = '';
                        lines.forEach(function (line) {
                            if (line.indexOf('a=mid:') === 0) {
                                current_mid = line;
                            }
                            if (line.indexOf('a=inactive') === 0 && current_mid.indexOf('a=mid:screenshare') === 0) {
                                this.removeScreenStreamEvent(p.peerId, this.remoteScreenStream);
                                this.remoteScreenStream = null;
                            }
                        }, this);
                    }
                })));
            }
        });
    }
    setPeerCandidate(peerId, sdpMid, sdpMLineIndex, sdp) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.peers
                .filter((c) => c.peerId === peerId)
                .map((c) => __awaiter(this, void 0, void 0, function* () {
                yield c.connection.addIceCandidate(new VoxeetRTCShim_1.RTCIceCandidate({
                    candidate: sdp,
                    sdpMLineIndex: sdpMLineIndex,
                    sdpMid: sdpMid,
                }));
            })));
        });
    }
    setPeerPosition(peerId, posX, posY) { }
    mutePeer(peerId, isMuted) {
        this.peers
            .filter((c) => c.peerId === peerId)
            .map((c) => {
            if (c.isMaster) {
                if (this.audioTrack) {
                    this.audioTrack.enabled = !isMuted;
                }
            }
            else {
                if (c.process) {
                    c.process.mute(isMuted);
                }
                this.audioTags.muteAudioTag(peerId, isMuted);
            }
        });
    }
    toggleMute(peerId) {
        var muted = false;
        this.peers
            .filter((c) => c.peerId === peerId)
            .map((c) => {
            if (c.isMaster) {
                muted = this.toggleOwnMute();
            }
            else {
                if (c.process) {
                    muted = c.process.toggleMute();
                }
                const nodeMute = this.audioTags.toggleMute(peerId);
                if (!this.audio3D) {
                    muted = nodeMute;
                }
            }
        });
        return muted;
    }
    isOwnMuted() {
        return this.audioTrack ? !this.audioTrack.enabled : true;
    }
    toggleOwnMute() {
        this.audioTrack.enabled = !this.audioTrack.enabled;
        return !this.audioTrack.enabled;
    }
    setGain(peerId, gain) {
        this.peers
            .filter((c) => c.peerId === peerId)
            .map((c) => {
            if (c.process) {
                c.process.setGain(gain);
            }
        });
    }
    getPeerPosition(peerId) {
        var peer = this.peers.find((p) => p.peerId === peerId);
        if (peer && peer.process && this.audio3D) {
            return { x: peer.process.x, y: peer.process.y };
        }
        return { x: 0, y: 0.5 };
    }
    getLevel(peerId, callback) {
        var level = 0;
        var peer = this.peers.find((p) => p.peerId === peerId);
        if (peer) {
            const promise = this._getProcessLevel(peer);
            return promise.then((level) => {
                callback(level);
            });
        }
        return callback(level);
    }
    isSpeaking(peerId, callback) {
        this.getLevel(peerId, (level) => {
            if (level > this.speechThreshold) {
                callback(true);
            }
            else {
                callback(false);
            }
        });
    }
    stopVideoForPeer(peerId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.peers
                .filter((c) => c.peerId === peerId)
                .map((c) => __awaiter(this, void 0, void 0, function* () {
                if (c.stream) {
                    if (c.isMaster) {
                        if (!this.localMediaStream || this.localMediaStream.getVideoTracks().length === 0) {
                            throw new Exceptions_1.MediaError('Already stopped');
                        }
                        var track = this.localMediaStream.getVideoTracks()[0];
                        track.stop();
                        this.localMediaStream.removeTrack(track);
                        yield this.removeTrack(track, c.connection, this.localMediaStream);
                        if (!this.localMediaStream.getVideoTracks().length) {
                            this.currentConstraints = null;
                        }
                        if (!this.localMediaStream.getTracks().length) {
                            this.removeStreamEvent(peerId, this.localMediaStream);
                            this.localMediaStream = null;
                        }
                        else {
                            this.updateStreamEvent(peerId, this.localMediaStream);
                        }
                    }
                }
            })));
        });
    }
    startVideoForPeer(peerId, constraints = Helpers_1.isMobile() ? config_1.default.media.mobile.constraints.video : config_1.default.media.constraints.video) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.peers
                .filter((c) => c.peerId === peerId)
                .map((c) => __awaiter(this, void 0, void 0, function* () {
                if (c.isMaster) {
                    if (this.localMediaStream && this.localMediaStream.getVideoTracks().length > 0) {
                        throw new Exceptions_1.MediaError('Already started');
                    }
                    // Checking constraints
                    this.constraints.video = constraints;
                    let newConstraints = JSON.parse(JSON.stringify(this.constraints));
                    newConstraints.audio = false;
                    try {
                        const stream = yield this.getUserMediaWithChecks(newConstraints);
                        yield this.applyBandwidthConstraints(stream.getVideoTracks()[0]);
                        if (this.localMediaStream) {
                            // Adding stream to the localmedistream has the addTrack shim don't do it
                            this.localMediaStream.addTrack(stream.getVideoTracks()[0]);
                            yield this.addTrack(this.localMediaStream.getVideoTracks()[0], c.connection, this.localMediaStream, 'video');
                            this.updateStreamEvent(peerId, this.localMediaStream);
                        }
                        else {
                            this.localMediaStream = stream;
                            this.localMediaStream.type = MediaStream_1.MediaStreamType.Camera;
                            c.stream = stream;
                            yield this.addStream(this.localMediaStream, c.connection);
                            this.addStreamEvent(peerId, this.localMediaStream);
                        }
                    }
                    catch (err) {
                        throw new Exceptions_1.MediaStreamError(err);
                    }
                }
            })));
        });
    }
    stopAudioForPeer(peerId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.peers
                .filter((c) => c.peerId === peerId)
                .map((c) => __awaiter(this, void 0, void 0, function* () {
                if (c.stream) {
                    if (c.isMaster) {
                        if (!this.localMediaStream || this.localMediaStream.getAudioTracks().length === 0) {
                            throw new Exceptions_1.MediaError('Already stopped');
                        }
                        let track = this.audioTrack;
                        track.stop();
                        track.enabled = false;
                        yield this.removeTrack(track, c.connection, this.localMediaStream);
                        this.localMediaStream.removeTrack(track);
                        // Disconnect AudioProcess
                        if (this.audioContext && c.process) {
                            c.process.disconnect();
                        }
                        if (!this.localMediaStream.getTracks().length) {
                            this.removeStreamEvent(peerId, this.localMediaStream);
                            this.localMediaStream = null;
                        }
                        else {
                            this.updateStreamEvent(peerId, this.localMediaStream);
                        }
                    }
                }
            })));
        });
    }
    startAudioForPeer(peerId, constraints = config_1.default.media.constraints.audio) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.peers
                .filter((c) => c.peerId === peerId)
                .map((c) => __awaiter(this, void 0, void 0, function* () {
                if (c.isMaster) {
                    if (this.localMediaStream && this.localMediaStream.getAudioTracks().length > 0) {
                        throw new Exceptions_1.MediaError('Already started');
                    }
                    // Checking constraintsi
                    this.constraints.audio = constraints;
                    let newConstraints = JSON.parse(JSON.stringify(this.constraints));
                    newConstraints.video = false;
                    try {
                        const stream = yield this.getUserMediaWithChecks(newConstraints);
                        this.audioTrack = stream.getAudioTracks()[0];
                        if (this.localMediaStream) {
                            // Adding stream to the localmedistream has the addTrack shim don't do it
                            this.localMediaStream.addTrack(this.audioTrack);
                            yield this.addTrack(this.audioTrack, c.connection, this.localMediaStream, 'audio');
                            this.updateStreamEvent(peerId, this.localMediaStream);
                        }
                        else {
                            this.localMediaStream = stream;
                            this.localMediaStream.type = MediaStream_1.MediaStreamType.Camera;
                            c.stream = stream;
                            yield this.addStream(this.localMediaStream, c.connection);
                            this.addStreamEvent(peerId, this.localMediaStream);
                        }
                        if (this.audioContext) {
                            // Udating AudioProcess
                            c.process = new AudioProcess_1.default(this.audioContext, this.localMediaStream, true, this.audio3D);
                            c.process.connect();
                        }
                    }
                    catch (err) {
                        throw new Exceptions_1.MediaStreamError(err);
                    }
                }
            })));
        });
    }
    selectAudioInput(deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.peers
                .filter((c) => c.isMaster === true)
                .map((c) => __awaiter(this, void 0, void 0, function* () {
                if (typeof this.constraints.audio !== 'object') {
                    this.constraints.audio = {};
                }
                let newConstraints = JSON.parse(JSON.stringify(this.constraints));
                newConstraints.audio.deviceId = { exact: deviceId };
                newConstraints.video = false; // Just looking for audio
                const enabled = this.audioTrack.enabled;
                this.audioTrack.stop();
                try {
                    const stream = yield this.getUserMediaWithChecks(newConstraints);
                    this.localMediaStream.removeTrack(this.localMediaStream.getAudioTracks()[0]);
                    this.audioTrack = stream.getAudioTracks()[0];
                    this.audioTrack.enabled = enabled;
                    this.localMediaStream.addTrack(this.audioTrack);
                    yield this.replaceTrack(this.audioTrack, c.connection, this.localMediaStream);
                    // Udating AudioProcess
                    if (this.audioContext && c.process) {
                        c.process.disconnect();
                        (c.process = new AudioProcess_1.default(this.audioContext, this.localMediaStream, true)), this.audio3D;
                        c.process.connect();
                    }
                    this.updateStreamEvent(c.peerId, c.stream);
                }
                catch (error) {
                    throw error;
                }
            })));
        });
    }
    selectVideoInput(deviceId, constraints = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.peers
                .filter((c) => c.isMaster === true)
                .map((c) => __awaiter(this, void 0, void 0, function* () {
                if (typeof this.constraints.video !== 'object') {
                    this.constraints.video = {};
                }
                let newConstraints = JSON.parse(JSON.stringify(this.constraints));
                newConstraints.video.deviceId = { exact: deviceId };
                newConstraints.audio = false; // Just looking for video
                this.localMediaStream.getVideoTracks()[0].stop();
                try {
                    const stream = yield this.getUserMediaWithChecks(newConstraints);
                    const oldVideoTrack = this.localMediaStream.getVideoTracks()[0];
                    this.localMediaStream.removeTrack(oldVideoTrack);
                    this.currentConstraints = null;
                    yield this.applyBandwidthConstraints(stream.getVideoTracks()[0]);
                    this.localMediaStream.addTrack(stream.getVideoTracks()[0]);
                    yield this.replaceTrack(stream.getVideoTracks()[0], c.connection, this.localMediaStream);
                    this.updateStreamEvent(c.peerId, c.stream);
                }
                catch (error) {
                    throw error;
                }
            })));
        });
    }
    selectAudioOutput(deviceId) {
        if (deviceId && this.audioTags) {
            this.audioTags.setSinkId(deviceId);
            return Promise.resolve();
        }
        return Promise.reject(new Error('Unavailable'));
    }
    startScreenShare(sourceId, cb) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.sharingStream) {
                this.sharingStream = yield navigator.mediaDevices.getDisplayMedia({ video: true, sourceId }); // Shim will take sourceId
                this.sharingStream.type = MediaStream_1.MediaStreamType.ScreenShare;
                return Promise.resolve(this.sharingStream);
            }
            else {
                return Promise.reject(new Error('Unable to start more than one screen share at a time.'));
            }
        });
    }
    releaseScreenShare() {
        if (this.sharingStream && this.sharingStream.getVideoTracks().length > 0) {
            this.sharingStream.getVideoTracks()[0].onended = null;
            this.sharingStream.getVideoTracks()[0].stop();
            this.sharingStream = null;
        }
    }
    addMasterScreenStream(stream) {
        return __awaiter(this, void 0, void 0, function* () {
            const peer = this.peers.find((p) => p.isMaster);
            if (peer && stream) {
                yield this.addScreenStream(stream, peer.connection);
                this.sharingStream.getVideoTracks()[0].onended = (e) => {
                    this.endedScreenStreamEvent();
                };
                this.addScreenStreamEvent(peer.peerId, this.sharingStream);
            }
        });
    }
    changeScreenShare(sourceId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.sharingStream) {
                this.sharingStream.getVideoTracks()[0].onended = null; // Avoid reaching stopScreenShare twice
                yield Promise.all(this.peers
                    .filter((c) => c.isMaster)
                    .map((p) => __awaiter(this, void 0, void 0, function* () {
                    yield this.removeScreenStream(this.sharingStream, p.connection);
                })));
                this.sharingStream.getVideoTracks()[0].stop();
                this.sharingStream = null;
                try {
                    const stream = yield navigator.mediaDevices.getDisplayMedia({
                        video: true,
                        sourceId,
                    });
                    if (this.sharingStream !== stream) {
                        this.sharingStream = stream;
                        yield Promise.all(this.peers
                            .filter((c) => c.isMaster)
                            .map((p) => __awaiter(this, void 0, void 0, function* () {
                            if (this.sharingStream) {
                                yield this.addScreenStream(this.sharingStream, p.connection);
                                this.sharingStream.getVideoTracks()[0].onended = (e) => {
                                    this.endedScreenStreamEvent();
                                };
                                this.updateScreenStreamEvent(p.peerId, this.sharingStream);
                            }
                        })));
                    }
                    return this.sharingStream;
                }
                catch (error) {
                    throw new Exceptions_1.MediaStreamError(error);
                }
            }
        });
    }
    stopScreenShare() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.sharingStream) {
                this.sharingStream.getVideoTracks()[0].onended = null; // Avoid reaching stopScreenShare twice
                yield Promise.all(this.peers
                    .filter((c) => c.isMaster)
                    .map((p) => __awaiter(this, void 0, void 0, function* () {
                    yield this.removeScreenStream(this.sharingStream, p.connection);
                })));
                yield Promise.all(this.peers
                    .filter((c) => c.isMaster)
                    .map((p) => __awaiter(this, void 0, void 0, function* () {
                    this.removeScreenStreamEvent(p.peerId, this.sharingStream);
                    this.sharingStream.getVideoTracks()[0].stop();
                    this.sharingStream = null;
                })));
            }
        });
    }
    // Changing local stream
    changeRecordingDevice() {
        getUserMedia(constraints, (stream) => { });
    }
    _getRtcForTrack(pc, track) {
        if (browser.is('chrome')) {
            return pc
                .getStats()
                .then((stats) => [...stats.values()].filter((s) => s.type === 'track' && s.trackIdentifier === track.id))
                .then((v) => v[0].audioLevel);
        }
        else {
            return pc.getStats(track).then((stats) => {
                return stats.ssrc && stats.ssrc.audioInputLevel ? stats.ssrc.audioInputLevel : stats.ssrc.audioOutputLevel;
            });
        }
    }
    _getRtcLevel(peer, callback) {
        if (peer.stream) {
            return this._getRtcForTrack(peer.connection, peer.stream.getAudioTracks()[0])
                .then((audioLevel) => (20.0 * Math.log10(audioLevel) + 70.0) / 80.0)
                .catch((e) => {
                return 0;
            });
        }
        return Promise.resolve(0);
    }
    _getProcessLevel(peer) {
        var level = 0;
        if (peer.process) {
            peer.process.update();
            level = peer.process.getLevel();
        }
        return Promise.resolve(level);
    }
    // Uniformazing getStats for chrome and firefox
    _getStats(pc, selector) {
        return pc.getStats(selector);
    }
    getInboundRtpStats() {
        return new Promise((resolve, reject) => {
            let result = {
                bytesReceived: 0,
                packetsReceived: 0,
            };
            this.peers
                .filter((c) => !c.isMaster)
                .map((p) => {
                p.connection.getStats().then((stats) => {
                    stats.forEach((s) => {
                        if (s.type === 'inbound-rtp') {
                            result['bytesReceived'] += s.bytesReceived;
                            result['packetsReceived'] += s.packetsReceived;
                        }
                    });
                    resolve(result);
                });
            });
        });
    }
    getRTCPeerConnections() {
        return this.peers.filter((p) => p.connection).map((p) => p.connection);
    }
    getRtpStats() {
        return __awaiter(this, void 0, void 0, function* () {
            const peer = this.peers.find((p) => p.isMaster);
            const stats = yield this.getRtpStatsForTelemetry();
            if (peer) {
                const candidatePair = stats.get(peer.peerId).filter((s) => s.type === 'candidate-pair');
                for (const [peerId, stat] of stats) {
                    let aScore = 0;
                    let vScore = 0;
                    if (peerId === peer.peerId) {
                        // Master / Sender
                        const remoteInboundAudioRtp = stat.filter((s) => (s.type === 'remote-inbound-rtp' || s.type === 'inbound-rtp') && s.kind === 'audio');
                        const outboundAudioRtp = stat.filter((s) => s.type === 'outbound-rtp' && s.kind === 'audio');
                        let lastOutboundAudioRtp = [];
                        if (this.lastStats[peerId]) {
                            lastOutboundAudioRtp = this.lastStats[peerId].filter((s) => s.type === 'outbound-rtp' && s.kind === 'audio');
                        }
                        if (remoteInboundAudioRtp.length > 0 &&
                            outboundAudioRtp.length > 0 &&
                            lastOutboundAudioRtp.length > 0 &&
                            outboundAudioRtp[0].bytesSent > lastOutboundAudioRtp[0].bytesSent) {
                            let rtt = candidatePair[0].currentRoundTripTime ? candidatePair[0].currentRoundTripTime : remoteInboundAudioRtp[0].roundTripTime;
                            // Workaround for Firefox: Sometimes remoteInboundAudioRtp[0].roundTripTime is missing in stats
                            rtt = rtt ? rtt : this.recentlySeenRTT;
                            this.recentlySeenRTT = rtt;
                            const fractionLost = parseFloat(remoteInboundAudioRtp[0].packetsLost) / parseFloat(outboundAudioRtp[0].packetsSent);
                            aScore = WebRtcUtils_1.audioScore(parseFloat(fractionLost * 100), parseFloat(rtt) * 1000, parseFloat(remoteInboundAudioRtp[0].jitter) * 1000);
                        }
                        if (this.localMediaStream) {
                            let videoTracks = this.localMediaStream.getVideoTracks();
                            vScore = WebRtcUtils_1.senderVideoScore(this.lastStats[peerId], stat, videoTracks);
                        }
                    }
                    else {
                        // Receivers
                        const inboundAudioRtp = stat.filter((s) => s.type === 'inbound-rtp' && s.kind === 'audio');
                        if (inboundAudioRtp.length > 0 && candidatePair.length > 0) {
                            const fractionLost = parseFloat(inboundAudioRtp[0].packetsLost) / parseFloat(inboundAudioRtp[0].packetsReceived);
                            aScore = WebRtcUtils_1.audioScore(parseFloat(fractionLost * 100), parseFloat(candidatePair[0].currentRoundTripTime) * 1000, parseFloat(inboundAudioRtp[0].jitter) * 1000);
                        }
                        const dvcs = this.peers.findIndex((peer) => peer.peerId === '00000000-0000-0000-0000-000000000000') > -1;
                        vScore = WebRtcUtils_1.videoScore(this.lastStats[peerId], stat, dvcs);
                    }
                    this.lastStats[peerId] = [...stat];
                    stats.set(peerId, [...stat, { id: 'Scores', audio: aScore, video: vScore }]);
                }
            }
            return stats;
        });
    }
    getRemoteScreenStreamInfo() {
        let remoteScreenPeerId = null;
        let remoteScreenStreamMsid = null;
        let remoteScreenTrackIds = null;
        if (this.remoteScreenStream) {
            const re = /([0-9]*)_?([a-zA-Z0-9]*)_?([0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12})/gm;
            const matches = re.exec(this.remoteScreenStream.id);
            remoteScreenPeerId = matches[3];
            remoteScreenStreamMsid = this.remoteScreenStream.id;
            remoteScreenTrackIds = this.remoteScreenStream.getVideoTracks().map((track) => track.id);
        }
        return [remoteScreenPeerId, remoteScreenStreamMsid, remoteScreenTrackIds];
    }
    getRemoteStats(connection, stats) {
        let result = new Map();
        let receivers = connection.getReceivers();
        let trackIdToSsrc = new Map(receivers.map((receiver) => [receiver.track.id, receiver.getSynchronizationSources().map((source) => source.source)]));
        const [remoteScreenPeerId, remoteScreenStreamMsid, remoteScreenTrackIds] = this.getRemoteScreenStreamInfo();
        this.peers.forEach(({ stream, peerId, isMaster }) => {
            if (!stream)
                return;
            if (isMaster)
                return;
            const tracks = getPeerTracks(stream, remoteScreenPeerId === peerId ? this.remoteScreenStream : null);
            let remoteStats = tracks.flatMap((track) => {
                if (!areInboundRtpStatsAvailableForTrack(stats, trackIdToSsrc, track.id))
                    return [];
                const trackStats = getTrackStats(stats, track);
                const inboundRtpStats = getInboundRtpStats(stats, trackIdToSsrc, trackStats);
                const streamStats = getStreamStats(stats, stream, trackStats, remoteScreenTrackIds, remoteScreenStreamMsid);
                return [inboundRtpStats, trackStats, streamStats];
            });
            result.set(peerId, remoteStats);
        });
        return result;
    }
    getLocalScreenShareInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.screenTransceiver == null || this.screenTransceiver.sender == null || this.screenTransceiver.sender.track == null)
                return [null, null];
            let senderOutboundStats = [...(yield this.screenTransceiver.sender.getStats()).values()].filter((s) => s.type === 'outbound-rtp');
            if (!senderOutboundStats[0])
                return [null, null];
            return [senderOutboundStats[0].ssrc, this.screenTransceiver.sender.track.id];
        });
    }
    addContentTypeToScreenShareOutboundRtpStats(outboundRtpStats, localScreenShareTrackSsrc, localScreenShareTrackid) {
        if (!localScreenShareTrackSsrc || !localScreenShareTrackid)
            return;
        outboundRtpStats
            .filter((s) => s.type === 'outbound-rtp')
            .forEach((s) => {
            if (s.ssrc === localScreenShareTrackSsrc) {
                if (!s.hasOwnProperty('contentType'))
                    s.contentType = 'screenshare';
                if (!s.hasOwnProperty('trackId'))
                    s.trackId = localScreenShareTrackid;
            }
        });
    }
    getRtpStatsForTelemetry() {
        return __awaiter(this, void 0, void 0, function* () {
            const peer = this.peers.find((p) => p.isMaster);
            let result = new Map();
            if (peer) {
                let stats = yield peer.connection.getStats(null);
                stats = [...stats.values()];
                const [localScreenShareTrackSsrc, localScreenShareTrackId] = yield this.getLocalScreenShareInfo();
                // Peer outbound stats, affected to Master
                const outboundStats = [];
                stats
                    .filter((s) => s.type === 'media-source' ||
                    s.type === 'outbound-rtp' ||
                    (s.type === 'remote-inbound-rtp' && s.localId) ||
                    s.type === 'candidate-pair' ||
                    s.type === 'inbound-rtp' ||
                    (s.type === 'track' && s.remoteSource === false)) // Filter remote outbound that are not associated with a localId
                    .forEach((s) => {
                    outboundStats.push(s);
                });
                // avoid browser differences in field names
                outboundStats.forEach((s) => {
                    if (!s.hasOwnProperty('kind') && s.hasOwnProperty('mediaType')) {
                        s.kind = s.mediaType;
                    }
                });
                this.addContentTypeToScreenShareOutboundRtpStats(outboundStats, localScreenShareTrackSsrc, localScreenShareTrackId);
                result.set(peer.peerId, outboundStats);
                result = new Map([...result, ...this.getRemoteStats(peer.connection, stats)]);
            }
            return result;
        });
    }
    _closePeerConnectionForPeer(peer) {
        if (peer.process) {
            peer.process.disconnect();
        }
        if (peer && peer.stream) {
            this.removeStreamEvent(peer.peerId, peer.stream); // To update ui
            peer.stream = null;
        }
        if (peer.connection && peer.connection.signalingState !== 'closed') {
            if (this.screenTransceiver && this.screenTransceiver.currentDirection !== 'inactive') {
                const stream = new MediaStream();
                stream.type = MediaStream_1.MediaStreamType.ScreenShare;
                this.removeScreenStreamEvent(peer.peerId, stream);
                if (this.screenTransceiver.sender.track) {
                    // Closing self screenshare
                    this.screenTransceiver.sender.track.stop();
                }
            }
            peer.connection.close();
        }
        if (peer) {
            peer.close = true;
        }
    }
    onScreenRemoveTrack(peerId, e) {
        this.remoteScreenStream = null;
        debug('stream onScreenRemoveTrack', e);
        e.target.type = MediaStream_1.MediaStreamType.ScreenShare;
        this.removeScreenStreamEvent(peerId, e.target);
    }
    addStream(stream, pc, index = MediaStream_1.MediaStreamIndex.Camera) {
        return __awaiter(this, void 0, void 0, function* () {
            debug('addStream', pc.getTransceivers(), pc.getSenders());
            let audioTransceiver, videoTransceiver;
            if (index == MediaStream_1.MediaStreamIndex.Camera) {
                this.audioTransceiver = pc.getTransceivers().find((t) => t.mid === 'audio');
                this.videoTransceiver = pc.getTransceivers().find((t) => t.mid === 'video');
                audioTransceiver = this.audioTransceiver;
                videoTransceiver = this.videoTransceiver;
            }
            else {
                audioTransceiver = pc.getTransceivers().find((t) => t.mid === `audio${index}`);
                videoTransceiver = pc.getTransceivers().find((t) => t.mid === `video${index}`);
            }
            if (audioTransceiver && stream.getAudioTracks().length > 0 && !this.wasm) {
                this.addTrack(stream.getAudioTracks()[0], pc, null);
            }
            if (videoTransceiver && stream.getVideoTracks().length > 0) {
                this.addTrack(stream.getVideoTracks()[0], pc, null);
                if (this.options && this.options.simulcast) {
                    try {
                        const parameters = videoTransceiver.sender.getParameters();
                        parameters.encodings[0].scaleResolutionDownBy = 4.0;
                        parameters.encodings[1].scaleResolutionDownBy = 2.0;
                        yield videoTransceiver.sender.setParameters(parameters);
                    }
                    catch (e) {
                        console.error("Simulcast can't be activated");
                        debug('simulcast error', e);
                    }
                }
            }
        });
    }
    setDirection(transceiver, direction) {
        if (transceiver.setDirection) {
            transceiver.setDirection(direction);
        }
        else {
            transceiver.direction = direction;
        }
    }
    addScreenStream(stream, pc) {
        return __awaiter(this, void 0, void 0, function* () {
            this.screenTransceiver = pc.getTransceivers().find((t) => t.mid === 'screenshare');
            debug('AddScreenStream', this.screenTransceiver, stream);
            if (this.screenTransceiver) {
                this.setDirection(this.screenTransceiver, 'sendonly');
                yield this.screenTransceiver.sender.replaceTrack(stream.getVideoTracks()[0]);
            }
        });
    }
    removeScreenStream(stream, pc) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.screenTransceiver) {
                this.setDirection(this.screenTransceiver, 'recvonly');
                yield this.screenTransceiver.sender.replaceTrack(null);
            }
        });
    }
    addTrack(track, pc, stream) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(pc.getTransceivers().map((t) => __awaiter(this, void 0, void 0, function* () {
                if (t.mid === track.kind) {
                    this.setDirection(t, t.mid === 'audio' ? 'sendrecv' : 'sendonly');
                    yield t.sender.replaceTrack(track);
                }
            })));
        });
    }
    removeTrack(track, pc, stream) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(pc.getTransceivers().map((t) => __awaiter(this, void 0, void 0, function* () {
                if (t.mid === track.kind) {
                    this.setDirection(t, t.mid === 'audio' ? 'recvonly' : 'inactive');
                    yield t.sender.replaceTrack(null);
                }
            })));
        });
    }
    replaceTrack(track, pc, stream) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(pc.getTransceivers().map((t) => __awaiter(this, void 0, void 0, function* () {
                if (t.mid === track.kind) {
                    yield t.sender.replaceTrack(track);
                }
            })));
        });
    }
}
exports.default = VoxeetRTCNative;
